import {Component , Vue} from "vue-property-decorator";
import { Getter, namespace } from "vuex-class";
import { WEBVIEW_TOKEN_QUERY, SERVICE_LINKS } from "../../common/constants";
import { LabelSetting } from "../../i18n/locale-helper";
import { AuthVerified } from "../../models/generic/auth-transfer";
import { storeModules } from "../../store";
import { ServiceVersionReader } from "../../utils/version/version-helper";

const CommonGetter = namespace(storeModules.Common, Getter);
@Component({
	name: "AboutComponent",
	template: require("./template.html"),
})

export default class AboutComponent extends Vue {
    public visible: boolean = false;
    version: any = {};
    lblSetting: any = LabelSetting.Global;
    public userInfo: any = {};
    linkURL = SERVICE_LINKS.WEBSITE_URL;
    isWebView: boolean = false;
    @CommonGetter userSession: AuthVerified;


    async created() {
		const urlQuery = new URLSearchParams(location.search);
		this.isWebView = !!urlQuery.get(WEBVIEW_TOKEN_QUERY);
    }

    async mounted() {
        const service = new ServiceVersionReader;
        this.version = await service.getVersion();

        if (this.isWebView) {
            this.userInfo = this.userSession.UserInfo;
            this.visible = true;
        }
    }

    handleClose() {
        this.visible = false;
    }
}